import { P as PageName } from './index2.js';

const wellKnownBookingEnginePages = [
    PageName.RoomsAndRates,
    PageName.Packages,
    PageName.Calendar,
    PageName.UserRegisterPage,
    PageName.BookingConfirmed,
];
const isBookingEnginePage = (pageName) => !!(pageName && wellKnownBookingEnginePages.includes(pageName));

export { isBookingEnginePage as i };
